import React from 'react';

import './Reading.css';

// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import * as bootstrap from 'react-bootstrap';

import Header from '../Header/Header';

import ReactImageFallback from "react-image-fallback";

import Cookies from 'universal-cookie';
class ReadingIndex extends React.Component{
    constructor(props){
        super(props); 
        this.state = {
            error: null,
            categorys:[],
            category_id: [],
            banners: [],
            books: [],
        }
        this.selectBook = this.selectBook.bind(this);
        this.selectBook_page = this.selectBook_page.bind(this);
    }

    componentDidMount(){
        // const apiUrl = 'http://localhost/ReactApi/category/category';

        // this.getCategory(apiUrl);
        this.onFormSubmit(this.state);
    }

    // getCategory = apiUrl =>{

    //     fetch(apiUrl)
    //         .then(res => res.json())
    //         .then(
    //             (result) => {
    //                 this.setState({
    //                     categorys: result.category
    //                 })
    //             },
    //             (error) => {
    //                 this.setState({ error })
    //             }
    //         )
    // }
    

    selectBook(e) {
        if(e.target.checked) {
            this.setState({
                data_page: "1",
                category_id: [ ...this.state.category_id, e.target.value],
                // aaaa: e.target.value,
            }, 
            () => {
                this.onFormSubmit(this.state);
            });
        }
        else{
            let remove = this.state.category_id.indexOf(e.target.value);
            this.setState({
                    data_page: "1",
                    category_id: this.state.category_id.filter((_, i) => i !== remove)
                },
                () => {
                    this.onFormSubmit(this.state);
                }
            );
        }
    }
    selectBook_page(e) {
        this.setState({
            data_page: e.target.getAttribute('data_page'),
        }, 
        () => {
            this.onFormSubmit(this.state);
        });
    }

    onFormSubmit(data) {
        const cookies = new Cookies();
        
        let apiUrl;
          apiUrl = cookies.get('baseUrlApi')+'reading';
    
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
    
        const options = {
          method: 'POST',
          body: JSON.stringify(data),
          myHeaders
        }
    
        fetch(apiUrl, options)
          .then(res => res.json())
          .then(
            (result) => {
                this.setState({
                    books: result.book,
                    page: result.page,
                    previous_page: result.previous_page,
                    next_page: result.next_page,
                    total_page: result.total_page,
                })     
            },
            (error) => {
              this.setState({ error });
            }
          )
    }
    
    
    render() {
        let table = [];
        var i;
        var page = this.state.page;
        var total_page = this.state.total_page;
        var p_active;

        var next_page = this.state.next_page;
        var previous_page = this.state.previous_page;
        
        table.push(
            <bootstrap.Pagination.Item id={"first_page"} data_page={1} key="first_page" onClick={this.selectBook_page}>First</bootstrap.Pagination.Item>
        )

        if(page === 1){
            table.push(
                <bootstrap.Pagination.Item id={"previous"} key="previous" disabled>Previous</bootstrap.Pagination.Item>
            )
        }else{
            table.push(
                <bootstrap.Pagination.Item id={"previous"} data_page={previous_page} key="previous" onClick={this.selectBook_page}>Previous</bootstrap.Pagination.Item>
            )
        }

        for (i = 1; i < total_page+1; i++) {
            if(i === page){p_active="active";}else{p_active="";} 

            if(page-2>=2 && (i>2 && i<page-2)){
                table.push(
                    <bootstrap.Pagination.Ellipsis key="p_1" />
                )
                i=page-2;
            }

            table.push(
                <bootstrap.Pagination.Item id={"page_"+i} data_page={i} className={p_active} key={i} onClick={this.selectBook_page} >{i}</bootstrap.Pagination.Item>
            )

            if(page+5<=total_page && (i>=page+2 && i<=total_page-2)){
                table.push(
                    <bootstrap.Pagination.Ellipsis key="p_2" />
                )
                i=total_page-2;
            }
        }

        if(page === total_page){
            table.push(
                <bootstrap.Pagination.Item id={"next"} key="Next" disabled>Next</bootstrap.Pagination.Item>
            )
        }else{
            table.push(
                <bootstrap.Pagination.Item id={"next"} data_page={next_page} key="Next" onClick={this.selectBook_page}>Next</bootstrap.Pagination.Item>
            )
        }

        
        table.push(
            <bootstrap.Pagination.Item id={"last_page"} data_page={total_page} key="last_page" onClick={this.selectBook_page}>Last</bootstrap.Pagination.Item>
        )
        
        const {error , books} = this.state;
 
        if(error){
            return(
                <div>Error: {error.message}</div>
            )
        }else{
            return (
                <div>
                    <Header />

                    <bootstrap.Container style={{paddingTop: "30px" ,paddingBottom: "20px"}}>
                        <bootstrap.Row>
                            <bootstrap.Col sm={12}>
                                <bootstrap.Row>
                                    <bootstrap.Col className="col_content" sm={12} md={12} lg={12} >
                                        <h1>การ์ตูนทดลองอ่าน </h1>
                                        <p>Siamintercomics</p>
                                        <br/>
                                        <h4 style={{borderBottom: "1px solid #ddd" , paddingBottom:"10px"}}>หนังสือทั้งหมด</h4>
                                        
                                        <bootstrap.Row>
                                            {books.map(book => (
                                                <bootstrap.Col key={book.id} xs={6} sm={6} md={3} lg={2} className="img_box">
                                                    <a href={`http://localhost:3000/reading/${book.id}`}>
                                                        <ReactImageFallback
                                                        src={`http://localhost/siamintercomics/${book.images}`}
                                                        fallbackImage={`https://www.smmpublishing.com/images/products/${book.images}`}
                                                        initialImage="loader.gif"
                                                        alt={book.book_name}
                                                        className="my-image reading_image" width="100%"/>
                                                    </a>
                                                </bootstrap.Col>
                                            ))} 
                                        
                                        </bootstrap.Row>
                                        <br/>
                                        <center>
                                            <bootstrap.Pagination>
                                                {table}
                                            </bootstrap.Pagination>
                                        </center>

                                    </bootstrap.Col>
                                </bootstrap.Row>
                            </bootstrap.Col>
                        </bootstrap.Row>
                    </bootstrap.Container>
                </div>
            );
        }
    }
}

export default ReadingIndex;